import {
  EventBus,
  EventWrapperViewMode,
  useProxy,
} from '@revenuewell/logic-wrapper-proxy';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { ViewModeType, WrapperViewModeContext } from './types';
import { isWebView } from '../../utils/mobile';


const DEFAULT_VIEW_MODE = isWebView() ? "Phone" : "Desktop";

export const WrapperViewModeContexts =
  createContext<WrapperViewModeContext>(null!);

export function WrapperViewProvider(props: React.PropsWithChildren<unknown>) {
  const [viewMode, setViewMode] = useState<ViewModeType>(DEFAULT_VIEW_MODE);

  const { proxy, listenEvent } = useProxy();

  useEffect(() => {
    if (proxy) {
      const handleWrapperViewMode = (event: EventBus) => {
        const { viewMode } = (event as EventWrapperViewMode).data;
        setViewMode(viewMode);
      };

      return listenEvent('wrapper-view-mode', handleWrapperViewMode);
    }
  }, [proxy]);

  const contextValue = { viewMode } as WrapperViewModeContext;

  return (
    <WrapperViewModeContexts.Provider value={contextValue}>
      {props.children}
    </WrapperViewModeContexts.Provider>
  );
}

export function useWrapperViewMode() {
  const context = useContext(WrapperViewModeContexts);

  if (!context) {
    throw new Error(
      'useWrapperViewMode must be used within the WrapperViewProvider'
    );
  }

  return context;
}
